<template>
	<v-container grid-list-md px-1 pb-0>
		<v-layout wrap>
			<v-flex xs12 sm12 md12>
				<h2>Klantgegevens</h2>
			</v-flex>
			<v-flex xs6 sm6 md4>
				<v-text-field
					label="Klantnummer"
					readonly
					v-model="user.user_id"
				></v-text-field>
			</v-flex>
			<v-flex xs6 sm6 md4>
				<v-text-field
					label="Voornaam"
					readonly
					v-model="user.firstname"
				></v-text-field>
			</v-flex>
			<v-flex xs6 sm6 md4>
				<v-text-field
					label="Achternaam"
					v-model="user.lastname"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs12 sm6 md6>
				<v-text-field
					label="Bedrijfsnaam"
					v-model="user.companyname"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs12 sm6 md6>
				<v-text-field
					label="Email"
					v-model="user.username"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs6>
				<v-text-field
					label="Rijbewijsnummer"
					type="text"
					v-model="user.licenseid"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs6>
				<v-text-field
					label="Geboortedatum"
					type="text"
					v-model="formattedBirthdate"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs6>
				<v-text-field
					label="Woonplaats"
					type="text"
					v-model="user.city"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs6>
				<v-text-field
					label="Postcode"
					type="text"
					v-model="user.zip"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs9>
				<v-text-field
					label="Adres"
					type="text"
					v-model="user.street"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs3>
				<v-text-field
					label="Huisnr"
					type="text"
					v-model="user.streetno"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs6>
				<v-text-field
					label="Telefoonummer"
					type="text"
					v-model="user.phoneno"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs6>
				<a :href="'#/users/' + user.user_id">Meer informatie</a>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import * as utils from '@/utils/utils';
import moment from 'moment';
import { _ } from 'vue-underscore';
export default {
	name: 'CustomerCard',
	components: {},
	created: function() {},
	data() {
		return {};
	},
	computed: {
		formattedBirthdate() {
			return moment(this.user.birthdate).format('DD-MM-YYYY');
		}
	},
	props: ['user']
};
</script>



// WEBPACK FOOTER //
// src/components/subcomponents/CustomerCard.vue